export default "__VITE_ASSET__D9uT3_An__"